import React from "react";
import "../css/Alerts.css";
import cargando from "../images/cargador_blanco.gif";
export default class Alerts extends React.Component{
    render() {
        return (
            <div className={"alert-container hide"}>
                <img src={cargando} alt=""/>
                <span className="item-18">Cargando</span>
            </div>
        );
    }
}